import { Box, Button, Image } from 'theme-ui'
import { useState } from 'react'

import Type from 'src/components/gel/Type'
import { Detail } from 'src/components/pages/adFormats/details/Details'
import Icon from 'src/components/gel/Icon'
import FormattedText from 'src/components/common/formattedText/FormattedText'

export interface LayoutProps {
  title: string
  description?: string
  image: { src: string; alt: string }
  assets: Detail[]
}

const LayoutSection = ({ props }: { props: LayoutProps }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false)
  const { title, description, image, assets } = props

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        height: [null, null, 'auto', 'auto'],
        py: [10]
      }}
    >
      <Box
        sx={{
          width: ['100%', null, '100%', 'calc(38.54% - 19px)'],
          order: [1, 1, 1, 1]
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            height: [null, null, 'auto', 'calc(100% - 72px)']
          }}
        >
          <Box
            sx={{
              pt: [5, null, 5, 0],
              pb: [5, null, 5, 0],
              pr: [2, null, 2, 8],
              pl: [2, null, 2, 4]
            }}
          >
            <Type variant="SectionTitleSans" sx={{ mb: [2, null, 6] }}>
              {title}
            </Type>
            {description && <Type variant={'Body'}>{description}</Type>}
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          width: ['100%', null, '100%', 'calc(61.57% + 16px)'],
          px: [2, null, 2, 0],
          order: [2, 2, 2, 2],
          position: 'relative',
          height: ['auto', null, 'auto', '100%']
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: ['auto', null, 'auto', '100%'],
            maxHeight: '452px',
            paddingBottom: ['56.25%', null, '56.25%', '0'],
            overflow: 'hidden'
          }}
        >
          <Image
            src={image.src}
            alt={image.alt}
            sx={{
              position: ['absolute', null, 'absolute', 'static'],
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
        </Box>

        {assets.length > 0 ? (
          <Box
            sx={{
              width: [null, null, '100%', '100%'],
              display: 'block',
              height: ['auto'],
              py: [2]
            }}
          >
            <Button
              variant={'buttons.longDropdown'}
              onClick={() => setIsAccordionOpen(!isAccordionOpen)}
              disabled={assets.length === 0}
              sx={{ width: '100%' }}
              as={'button'}
            >
              <Box sx={{ display: 'flex' }}>
                <Type variant="Labels" as="span">
                  {'Required Asset List'}
                </Type>
                <Box sx={{ width: 'fit-content', position: 'absolute', right: 0, pr: [2] }}>
                  <Icon
                    variant={isAccordionOpen ? 'GelIconChevronUp' : 'GelIconChevronDown'}
                    sx={{
                      mb: 1,
                      verticalAlign: 'middle',
                      alignContent: 'center',
                      display: 'inline-flex',
                      width: '20px',
                      height: '20px'
                    }}
                  />
                </Box>
              </Box>
            </Button>
            {isAccordionOpen ? (
              assets.map((asset, idx) => {
                return (
                  <Box
                    key={idx}
                    sx={{
                      height: 'auto',
                      borderBottom: '1.5px solid #9E9E9E',
                      display: 'flex',
                      py: [null, null, 2, 4]
                    }}
                  >
                    <Box
                      sx={{
                        height: '22px',
                        width: ['100%', '100%', '100%', 'calc(37.5% - 16px']
                      }}
                    >
                      <Type variant="BodyEmphasised">{asset.label}</Type>
                    </Box>
                    <Box
                      sx={{
                        width: ['100%', '100%', '100%', 'calc(62.5% + 16px'],
                        height: 'auto'
                      }}
                    >
                      <FormattedText text={asset.value.trim()} />
                    </Box>
                  </Box>
                )
              })
            ) : (
              <Box as="hr" sx={{ border: 'secondaryThin' }} />
            )}
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}

export default LayoutSection
